// extracted by mini-css-extract-plugin
module.exports = {"bb-quick-links":"bb-quick-links__M6SbP"};